// extracted by mini-css-extract-plugin
module.exports = {"label":"TextArea_label__XXRIB","textbox":"TextArea_textbox__psw5w","error":"TextArea_error__2kC28"};